import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import styles from "./page-content.module.scss";
export type PageContentProps = Readonly<{
  children: React.ReactNode;
  className?: string;
  flush?: boolean;
  /** Locks the page to the sidebar viewport; only inner regions scroll (roadmap table). */
  lockHeight?: boolean;
}>;
export function PageContent(t0) {
  const $ = _c(13);
  const {
    children,
    className,
    flush: t1,
    lockHeight: t2
  } = t0;
  const flush = t1 === undefined ? false : t1;
  const lockHeight = t2 === undefined ? false : t2;
  const t3 = flush ? styles.outerFlush : styles.outer;
  const t4 = lockHeight && styles.outerLock;
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = cn(t3, t4);
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = flush ? styles.innerFlush : styles.inner;
  const t7 = lockHeight && styles.innerLock;
  let t8;
  if ($[3] !== className || $[4] !== t6 || $[5] !== t7) {
    t8 = cn(t6, t7, className);
    $[3] = className;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== children || $[8] !== t8) {
    t9 = <div className={t8}>{children}</div>;
    $[7] = children;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t5 || $[11] !== t9) {
    t10 = <div className={t5}>{t9}</div>;
    $[10] = t5;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
}